const profileInfoTransPath = 'onboard.professionalInformation.';
const commonBtnPath = 'button.'

const profileInfoFormPath = profileInfoTransPath + 'formLabels.';
const profileInfoMsgPath = profileInfoTransPath + 'msg.';
const profileInfoMsgErrorPath = profileInfoMsgPath + 'error.';

const translations = {
    PAGE_INFO_TITLE: profileInfoTransPath + "title",

    // Form labels
    PRIMARY_SPECIALTY: profileInfoFormPath + "primarySpecialty",
    NPI_LABEL: profileInfoFormPath + "npi",
    PRACTICE_DATE_INFO: profileInfoFormPath + "practiceDateInfo",
    PRACTICE_DATES: profileInfoFormPath + "practiceDate",
    COMMUNICATION_TYPE: profileInfoFormPath + "communicationType",

    // Error messages
    ERROR_PRIMARY_SPECIALTY: profileInfoMsgErrorPath + "specialty",
    ERROR_INVALID_NPI: profileInfoMsgErrorPath + "invalidNpi",
    ERROR_REQUIRED_NPI: profileInfoMsgErrorPath + "noNpi",
    ERROR_PRACTICE_MONTH: profileInfoMsgErrorPath + "noPracticeMonth",
    ERROR_PRACTICE_YEAR: profileInfoMsgErrorPath + "noPracticeYear",
    ERROR_COMMUNICATION_TYPE: profileInfoMsgErrorPath + "noCommunicationType",

    NEXT_BUTTON_LABEL: commonBtnPath + "nextPracticeInfo"
}

export default translations;